import React, {useState} from 'react';
import {Col, Row} from "reactstrap";
import FormWithActions from "../Elements/FormWithActions/FormWithActions";
import FormGroupRowSelect from "../Elements/FormGroupRowSelect";

const SenderOnboardingDownloadConnectionAgreementForm = ({senderOnboarding, onAction}) => {
    const [language, setLanguage] = useState(senderOnboarding.language);

    const handleAction = () => {
        return onAction(language);
    };

    return (
        <>
            <Row>
                <Col>
                    <h1 className="mb-5">
                        Download connection agreement
                    </h1>
                </Col>
            </Row>
            <FormWithActions onAction={handleAction} submitButton="Download connection agreement">
                <FormGroupRowSelect
                    label="Language"
                    value={language}
                    onChange={setLanguage}
                    options={[
                        {value: 'nl' ,label: 'NL'},
                        {value: 'fr' ,label: 'FR'},
                        {value: 'en' ,label: 'EN'},
                    ]}
                />
            </FormWithActions>
        </>
    );
};

export default SenderOnboardingDownloadConnectionAgreementForm;